<style>
.menu-show {
  

}
.show-res {
  width: 100%;
  height: 100%;
}

.after-res {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  width: 100%;
  background: url(../assets/res.gif);
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: 100px;
}
.after-res .after-title {
  color: #57f3bb;
  font-size: 100px;
  font-weight: bold;
  font-family: "SofiaProBoldAz";
  margin-top: 30px;
  margin-bottom: 30px;
}
.after-res .after-amount {
  color: #000000;
  font-family: "SofiaProBoldAz";
  font-size: 60px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.after-res .after-amount span {
  color: #57f3bb;
}

.res-title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: start;
  background-color: #57f3bb;
  box-shadow: 0px 4px 38px rgb(0 0 0 / 13%);
  padding-left: 50%;
  margin-left: -50%;
  padding-right: 30px;
  height: 200px;
  width: 100%;
  z-index: 60;
  z-index: 50;
  margin-top: 200px;
}

.res-title span {
  font-style: normal;
  font-weight: bold;
  font-size: 100px;
  line-height: 91%;
  letter-spacing: 0px;
  color: #fff;
  font-family: "SofiaProBoldAz";
}

.results-wait {
  margin-top: -16%;
  display: flex;
  flex-direction: column;
  align-items: end;
  height: 100px;
  width: 100%;
}
.results-wait img {
  height: 400px;
  width: 300px;
}

.search-filter {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-top: 100px;
}

.search-filter span {
  font-size: 40px;
  font-family: "SofiaProMediumAz";
  font-weight: 600;
}

.btn-res {
  color: #fff;
  background-color: #57f3bb;
  height: 60px;
  border: none;
  border-radius: 4px;
  width: 300px;
  font-size: 33px;
  cursor: pointer;
  margin-top: 30px;
  margin-bottom: 30px;
}

@media only screen and (max-width: 768px) {
  .res-title {
    padding-left: 30%;
    margin-left: -30%;
    height: 100px;
    justify-content: center;
  }
  .results-wait {
    margin-top: 50px;
    justify-content: center;
    align-items: center;
  }
  .results-wait img {
    height: 100px;
    width: 100px;
  }
  .res-title span {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 91%;
    letter-spacing: 0px;
    color: #fff;
    font-family: "SofiaProBoldAz";
  }
  .search-filter {
    margin-top: 30px;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
  .search-filter span {
    font-size: 18px;
  }

  .after-res .after-title {
    font-size: 22px;
  }
  .after-res .after-amount {
    font-size: 22px;
  }
  .btn-res {
    font-size: 22px;
    width: 200px;
  }
}
</style>

<template>
  <div>
    <div class="menu-show">
      <MainMenu />
    </div>

    <div class="container">
      <div class="show-res">
        <div v-if="user.result.data" class="after-res">
          <div class="after-title">
            {{ user.retailers.fullname }}, We’ve Got It!
          </div>
          <div class="after-amount">
            <p class="">
              We Found
              <span>{{ user.result.data.total.value }}</span> Influencers
            </p>
            <p class="">Who Can Help You Grow Your Business</p>
          </div>
          <button class="btn-res" @click="redirectResult">
            Go To Results
          </button>
        </div>
        <div v-else class="before-res">
          <div class="res-title">
            <span>Searching...</span>
          </div>

          <div class="search-filter">
            <span class="">{{ user.retailers.followers_title }} </span>
            <span class=""
              >In The Field of {{ user.retailers.final_cat }}
            </span>
            <span class="">
              That Will Locate and Reach Customers In
              {{ user.retailers.country }}
            </span>
          </div>

          <div class="results-wait">
            <img src="../assets/gifSearch.gif" class="gif" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router.js";
import { mapState, mapActions } from "vuex";

import MainMenu from "../components/MainMenu";
import Card from "../components/Card";

export default {
  name: "RetailersBeforeResults",
  data() {
    return {};
  },
  components: {
    MainMenu,
    Card,
  },
  computed: mapState(["user"]),

  methods: {
    redirectResult: function() {
      router.push({ name: "RetailersResults" });
    },
  },
  mounted() {
    this.$store.dispatch("getSearchResult");
  },
};
</script>
